import ResponseError from "../types/responseError"
import { HttpStatusCodes } from "./HttpStatusCodes"

export default function buildCarrotApiRetryPolicy(maxFailures: number) {
  return function (failureCount: number, error: ResponseError): boolean {
    const statusCodesToNotRetry = [
      HttpStatusCodes.UNAUTHORIZED,
      HttpStatusCodes.FORBIDDEN,
      HttpStatusCodes.BAD_REQUEST,
      HttpStatusCodes.NOT_FOUND
    ]

    // Handle both ResponseError (has statusCode) and FetchWrapper Error (has response.status)
    const statusCode =
      (error as ResponseError).statusCode ?? (error as Error & { response?: Response })?.response?.status

    if (statusCode === undefined) {
      // If we can't determine status code, don't retry
      return false
    }

    return !statusCodesToNotRetry.includes(statusCode) && failureCount < maxFailures
  }
}
